import React from "react"
import PropTypes from "prop-types"

const WidgetFrameLayout = ({ children, externalIdentifier, onClose, widgetId }) => (
  <section className="hero is-fullheight has-background-light">
    <div id="bg-overlay"></div>
    <div id={widgetId} className="hero-body home-widget">
      <div className="card" style={{ position: 'relative' }}>
        <h2 className="has-text-weight-semibold is-size-4 mb-3">User Identifier: {externalIdentifier}</h2>
        {children}
        <button
          className="modal-close is-large"
          aria-label="close"
          onClick={onClose}
          style={{
            backgroundColor: '#0b0047',
            position: 'absolute',
            right: '1rem',
            top: '1rem',
            zIndex: 2
          }}
        ></button>
      </div>
    </div>
  </section>
)

WidgetFrameLayout.propTypes = {
  children: PropTypes.node,
  externalIdentifier: PropTypes.string,
  onClose: PropTypes.func,
  widgetId: PropTypes.string
}

export default WidgetFrameLayout
